import type { NAuth, NLeads, WithActiveBranchId } from '@app/types';

export namespace NLeadsApi {
  export type AssignLeadsToUserBySearchIdResponse = NLeads.ModelLead;
  export interface AssignLeadsToUserBySearchIdRequest {
    searchId: string;
    forUserId: number;
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
  }
  export interface SetLeadsTagsBySearchIdRequest {
    SearchId: string;
    TagIds: Array<string>;
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
  }
  export interface DeleteLeadsBySearchIdRequest {
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
    searchId: string;
  }
  export interface AssignLeadsToUserRequest {
    Database: NAuth.UserPrint['database'];
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
    UserId: NAuth.UserPrint['userId'];
    forUserId: number;
    data: Array<NLeads.ModelLead['Id']>;
  }
}

export enum Methods {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export interface AccessRightsModuleDto {
  Name: string | null;
  Allowed: boolean;
  RightType: number;
}
export interface GetOrganizationWithModulesDto {
  Id: number;
  Name: string | null;
  Modules: AccessRightsModuleDto[];
}

export interface GetModulesRightsByIdRequest extends WithActiveBranchId {
  id: number;
}
